module.exports = __webpack_public_path__ + "img/remove-icon.7911ddc3.svg";